export function contentVideo() {
	// $(".video-holder .play-button").on("click", function () {
	// 	$(this).parent().addClass("video-play");
	// 	let video = $(this).next("video");
	// 	video.get(0).play();
	// 	video.get(0).setAttribute('loop', true);
	// });

	const $window = $(window);
	let videoHolder = $(".video-holder");
	$window.on("scroll load", () => {
		videoHolder.each((i, item) => {
			if ($window.scrollTop() > $(item).offset().top - $window.height() * .95 && !$(item).hasClass("video-play")) {
				$(item).addClass("video-play").find("video").get(0).play();
			}
		});
	});


}


// WEBPACK FOOTER //
// ./assets/js/modules/contentVideo.js